<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>
          <v-app-bar flat>
            <v-icon>adjust</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Planes de Crédito</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Nombre"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">                        
                        <tr @click="viewItem(item)">
                          <td class="text-xs-left">{{ item.empresa }}</td>
                          <td class="text-xs-left">{{ item.nombre }}</td>
                          <td class="text-xs-left">{{ item.productoDescripcion }}</td>
                          <td class="text-xs-left">{{ item.anulado?"Si":" " }}</td>

                          <td class="text-xs-left">                
                            <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                            <v-icon small class ="mr-2"  @click="deleteItem(item)" v-show="canDelete">delete</v-icon>
                            <v-icon small  @click="editDatosBcraItem(item)">assignment</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 v-if="verDetalle">
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>receipt</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <!-- <v-btn v-if="model.id != null" :color="$store.state.UiColors.crudToolbarDetailButtons" top left @click="verCanalesVentaAsociados()" v-show="canCreate">                        
                        Ver canales de Venta Asociados
                      </v-btn> -->
                      <!-- <v-dialog v-model="dialogCanalesVenta" persistent max-width="600px">
                            <app-lista-canalesventa propName= "listaCanalesVenta" :value="listaCanalesVenta" v-on:close-dialog="closeDialog"></app-lista-canalesventa>                          
                      </v-dialog>-->
                      <v-spacer></v-spacer>
                       
                      <v-tooltip bottom  v-if="editMode">
                        <template v-slot:activator="{ on }">
                            <v-btn fab small top :color="$store.state.UiColors.crudToolbarDetailButtons" v-on="on" @click="guardarPlanComo">
                              <v-icon  medium>file_copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Copiar Plan</span>
                      </v-tooltip>

                      <v-tooltip bottom >
                        <template v-slot:activator="{ on }">
                            <v-btn fab small top color="orange" dark v-on="on" @click="generarReporte(model)">
                              <v-icon  medium>print</v-icon>
                            </v-btn>
                        </template>
                        <span>Generar Reporte Cuotas por Plan</span>
                      </v-tooltip>
                        
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                        <v-icon  medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode" >
                          <v-layout>
                            <v-flex xs6>
                              <v-text-field v-model="model.nombre" label="Nombre" :disabled="!editMode" v-validate="'required'" data-vv-name="nombre" 
                                :error-messages="errors.collect('nombre')"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-autocomplete 
                                  v-model="model.empresaId" 
                                  :items="empresas" 
                                  item-text="nombre" 
                                  item-value="id" 
                                  label="Empresa" 
                                  placeholder="Seleccione una empresa" 
                                  :disabled="!editMode" 
                                  :v-validate="'required | min_value:1'" data-vv-name="empresa"
                                  :error-messages="errors.collect('empresa')"
                                  :menu-props="{minWidth:'400'}">
                              </v-autocomplete>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6>
                              <v-autocomplete v-model="model.productoId" :items="productos" ref="producto"
                                    item-text="descripcion" item-value="id" label="Producto" placeholder="Seleccione un producto" 
                                    :disabled="!editMode" :menu-props="{minWidth:'400'}" v-validate="'required'" data-vv-name="producto" 
                                    :error-messages="errors.collect('producto')"></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                                <v-checkbox
                                    v-model="model.status.baja"
                                    label="Anulado"
                                    :disabled="!editMode">>
                                </v-checkbox>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs4>
                                <v-switch label="Establecer Vigencia"
                                            v-model="model.establecerVigencia"
                                            :disabled="!editMode">
                                </v-switch>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field v-model="model.vigenciaDesdeFormatted" label="Vigencia Desde" type="date" prepend-icon="event" 
                                    @input="vigenciaDesdeChanged" :disabled="!editMode" v-if="model.establecerVigencia"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field v-model="model.vigenciaHastaFormatted" label="Vigencia Hasta" type="date" prepend-icon="event" 
                                    @input="vigenciaHastaChanged" :disabled="!editMode" v-if="model.establecerVigencia"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-layout>
                            <v-flex xs4>
                                <v-switch label="Grilla Única"
                                            v-model="model.grillaUnica"
                                            :disabled="!editMode">
                                </v-switch>
                            </v-flex>

                            <v-flex xs8 v-if="model.grillaUnica">
                                <v-autocomplete :items="tablasCoeficientes" v-model="model.tablaCoeficientesId"
                                      item-text="nombre" item-value="id" label="Utilizar Grilla" 
                                      placeholder="Seleccione una Tabla de Coeficientes" 
                                      :disabled="!editMode" :menu-props="{minWidth:'400'}"
                                      :prepend-icon="'visibility'" @click:prepend="traerCoeficientesTabla(model.tablaCoeficientesId)"
                                      ></v-autocomplete>
                            </v-flex>

                          </v-layout>

                          <v-layout v-if="$store.state.parametrosGenerales.cargosAtrasoPor == 'plan'">
                            <v-flex xs4>
                                <v-switch label="Política Comercial Única"
                                            v-model="model.politicaComercialUnica"
                                            :disabled="!editMode">
                                </v-switch>
                            </v-flex>

                            <v-flex xs8 v-if="model.politicaComercialUnica">
                                <v-autocomplete :items="listaPoliticasComerciales" v-model="model.politicaComercialId"
                                        item-text="nombre" item-value="id" label="Utilizar Política" 
                                        placeholder="Seleccione una Política" 
                                        :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                            </v-flex>
                            
                            
                            <v-container grid-list-xs  v-if="!model.politicaComercialUnica">
                              <template v-for="calificacion in model.politicasComerciales" >
                                <v-layout :key="calificacion.id">
                                  <v-flex xs8>
                                    <v-autocomplete :items="listaPoliticasComerciales" v-model="calificacion.politicaComercialId"
                                            item-text="nombre" item-value="id" :label="calificacion.clasificacionParaLista" 
                                            placeholder="Seleccione una Política" 
                                            :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                                  </v-flex>
                                </v-layout>
                              </template>
                            </v-container>
                          </v-layout>
                          
                          <v-expansion-panels  v-if="!model.grillaUnica">
                            <v-expansion-panel ripple >
                              <template v-slot:actions>
                                <v-icon>edit</v-icon>
                              </template>
                              <template v-slot:header>
                                <v-card>
                                  <v-card-title primary-title>
                                    <div>
                                      <span class="grey--text">Grillas Habilitadas</span><br>
                                    </div>
                                  </v-card-title>
                                  <v-card-text>
                                    <template v-for="calificacion in model.tablasCoeficientes">
                                      <v-layout :key="calificacion.id" v-if="calificacion.tablaCoeficientesId > 0" column >
                                        <v-flex >
                                          {{calificacion.clasificacionParaLista}} {{calificacion.tablaCoeficientesNombre}}
                                        </v-flex>
                                      </v-layout>
                                    </template>
                                  </v-card-text>
                                </v-card>
                              </template>
                              
                              <v-card>
                                <v-card-text>
                                <template v-for="calificacion in model.tablasCoeficientes">
                                  <v-layout :key="calificacion.id">
                                    <v-flex xs8>
                                      <v-autocomplete :items="tablasCoeficientes" v-model="calificacion.tablaCoeficientesId"
                                              item-text="nombre" item-value="id" :label="calificacion.clasificacionParaLista" 
                                              placeholder="Seleccione una Tabla de Coeficientes" 
                                              :disabled="!editMode" :menu-props="{minWidth:'400'}"
                                              :prepend-icon="'visibility'" @click:prepend="traerCoeficientesTabla(calificacion.tablaCoeficientesId)"
                                              ></v-autocomplete>
                                    </v-flex>
                                  </v-layout>
                                </template>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel>
                          </v-expansion-panels> 

                          <v-flex xs6>
                            <v-autocomplete
                              v-model="model.modeloSmsBienvenidaId"
                              :items="listModelosSMS"
                              autocomplete="disabled"
                              :disabled="!editMode"
                              clearable
                              item-text="descripcion"
                              item-value="id"
                              label="Modelo de SMS Bienvenida"
                              hint="(si no se selecciona, se enviará el mensaje predeterminado)"
                              persistent-hint
                            ></v-autocomplete>
                          </v-flex>
                                

                          <p></p>
                          <p>Definición del plan</p>
                          <v-layout>

                              <!-- <v-flex xs4>
                                  <v-autocomplete 
                                    v-model="model.tablaCoeficientesId" 
                                    :items="tablasCoeficientes" 
                                    item-text="nombre" 
                                    item-value="id" 
                                    label="Tabla de Coeficientes" 
                                    placeholder="Seleccione una" 
                                    :disabled="!editMode" 
                                    :menu-props ="{minWidth:'400'}"
                                    
                                    :prepend-icon="editMode ? 'visibility' : 'search-disabled'" @click:prepend="traerCoeficientesTabla(model.tablaCoeficientesId)">
                                    
                                  </v-autocomplete>
                              </v-flex> -->

                              <v-dialog v-model="dialog" persistent max-width="600px">
                                <v-card>
                                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                                      <v-icon>list</v-icon>
                                      <v-toolbar-title class="font-weight-light">Lista de Coeficientes</v-toolbar-title>
                                      <v-spacer></v-spacer>
                                    </v-app-bar>
                                    <app-lista-tasas propName= "listaCoeficientes" :value="listaCoeficientes" :editMode='false'></app-lista-tasas>
                                  <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                                  </v-card-actions>
                                </v-card >
                                
                              </v-dialog>

                              <v-flex xs4>
                                  <v-autocomplete v-model="model.condicionPagoId" :items="condicionesPago" 
                                        item-text="descripcion" item-value="id" label="Condición de pago" placeholder="Seleccione una" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                              </v-flex>
                              <v-flex xs4>
                                  <v-autocomplete v-model="model.medioCobroId" :items="mediosCobro" 
                                        item-text="descripcion" item-value="id" label="Medio de cobro" placeholder="Seleccione uno" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                              </v-flex>
                              <v-flex xs4>
                                  <v-autocomplete v-model="model.medioPagoId" :items="mediosPago" clearable
                                        item-text="descripcion" item-value="id" label="Medio de Desembolso" placeholder="Cualquiera" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                              </v-flex>

                              <v-flex xs3>
                                  <v-checkbox
                                        v-model="model.noCalcularPunitorios"
                                        label="No calcular Punitorios"
                                        :disabled="!editMode">>
                                  </v-checkbox>
                              </v-flex>
                          </v-layout>

                          <v-layout>
                              <v-flex xs3>
                                  <v-autocomplete v-model="model.vencimientosMensuales" :items="vtosMensuales" 
                                        label="Vtos. al mes" placeholder="Elija" :disabled="!editMode" :menu-props="{width:'100'}"></v-autocomplete>
                              </v-flex>
                              <v-flex xs3>
                                  <v-checkbox
                                        v-model="model.noCalcularDiaCobro"
                                        label="No calcular día de cobro"
                                        :disabled="!editMode">>
                                  </v-checkbox>
                              </v-flex>
                              <v-flex xs3>
                                  <v-checkbox
                                        v-model="model.cuotaAdelantada"
                                        label="Cuota Adelantada"
                                        :disabled="!editMode">>
                                  </v-checkbox>
                              </v-flex>
                              <v-flex xs3>
                                  <v-checkbox
                                        v-model="model.redondeaCuota"
                                        label="Redondea Cuota"
                                        :disabled="!editMode">>
                                  </v-checkbox>
                              </v-flex>
                          </v-layout>

                          <p>Vencimiento de Cuota</p>

                          <v-row>
                              <v-col cols="5">
                                  <v-radio-group v-model="model.vencimiento.diaFijo" :mandatory="true" :disabled="!editMode">
                                    <v-radio v-bind:value="true">
                                      <div slot="label">
                                        {{ esProductoAdelanto ? 'Días de Vencimiento' : 'Día Fijo' }}
                                      </div>
                                    </v-radio>
                                    <v-radio v-if="!esProductoAdelanto" v-bind:value="false">
                                      <div slot="label">Según Fecha de Cobro del Cliente</div>
                                    </v-radio>
                                  </v-radio-group>
                              </v-col>
                              <v-col cols="2">
                                  <v-text-field 
                                  v-model="model.vencimiento.diaDesde" 
                                  :label="esProductoAdelanto ? 'Días Mínimo' : 'Día'" v-if ="model.vencimiento.diaFijo" :disabled="!editMode"></v-text-field>
                              </v-col>
                              <v-col cols="2">
                                  <v-text-field v-model="model.vencimiento.diaHasta" 
                                  :label="esProductoAdelanto ? 'Días Máximo' : 'Fecha Corte'"  v-if ="model.vencimiento.diaFijo" :disabled="!editMode"></v-text-field>
                              </v-col>
                              <v-col cols="3">
                                <v-autocomplete v-model="model.vencimiento.meses" :items="[1,2]" 
                                  label="Primera cuota en meses" placeholder="Elija" :disabled="!editMode" :menu-props="{width:'100'}"></v-autocomplete>
                              </v-col>
                          </v-row>

                          <v-container v-if="$store.state.parametrosGenerales.cargosAtrasoPor == 'plan'" fluid>
                            <span class="subtitle-1">Cargos Por Atraso</span>
                            <v-row>
                              <v-col>
                                <v-autocomplete v-model="model.coeficienteCargosAtrasoId" :items="listaCoeficientesAtraso" clearable
                                  item-text="nombre" item-value="id" label="Grilla de Cargos por Atraso" placeholder="Seleccione una" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                          
                              </v-col> 
                              <v-col cols="6">
                            <v-text-field  dense v-model="model.diasDeGracia"
                      label="Dias de Gracia"                        
                    ></v-text-field>
                            </v-col>
                            </v-row>
                          </v-container>  

                          <v-container  fluid>
                             <span class="subtitle-1">Gastos en el  Otorgamiento</span>

                            <app-lista-cargos propName= "listaCargos" :value="model.cargos" :editMode="editMode"></app-lista-cargos>
                          </v-container>

                          <v-divider></v-divider>
                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>            
                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions bottom>
                            <v-speed-dial direction="right" open-on-hover>
                              <template v-slot:activator>
                                <v-btn color="orange" text small v-show="editMode">
                                    <v-icon color="orange">touch_app</v-icon>                                
                                    Mas Acciones
                                  </v-btn>
                              </template>
                              <v-btn small text color="green" @click="guardarPlanComo" v-show="editMode">
                                Guardar Como
                              </v-btn>
                            </v-speed-dial>
                             
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 v-if="verDatosBcra">
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-toolbar-title class="font-weight-light">Datos BCRA</v-toolbar-title>
                    </v-app-bar>
                       <v-card-text>
                        <v-form >
                          
                          <v-row>
                            <v-col> <span class="body-1">Plan: {{planSeleccionado.nombre}}</span></v-col>
                            
                          </v-row>

                          <v-layout>
                            <v-flex xs6>
                              <v-text-field v-model="modelBcra.montoMaximoOtorgable" label="Monto Máximo Otorgable"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field v-model="modelBcra.montoMinimoOtorgable" label="Monto Mínimo Otorgable"></v-text-field>
                            </v-flex>
                          </v-layout>    
                           <v-layout>
                            <v-flex xs6>
                              <v-text-field v-model="modelBcra.ingresoMinimoMensual" label="Ingreso Mínimo Mensual Solicitado"></v-text-field>
                            </v-flex>
                          </v-layout>
                           <v-layout>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.antiguedadMinima" label="Antig. Laboral Mínima (meses)"></v-text-field>
                            </v-flex>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.edadMinima" label="Edad Mínima Solicitada"></v-text-field>
                            </v-flex>
                          </v-layout>
                           <v-layout>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.relacionCuotaIngreso" label="Relación cuota/ingreso (%)"></v-text-field>
                            </v-flex>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.beneficiario" label="Beneficiario"></v-text-field>
                            </v-flex>
                          </v-layout>
                           <v-layout>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.cargoMaximoCancelacionAnticipada" label="Cargo Máx.  Cancela Ant. (%)"></v-text-field>
                            </v-flex>
                              <v-flex xs6>
                              <v-text-field v-model="modelBcra.territorioValidezOferta" label="Territorio de Validez de la Oferta"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-card-actions bottom>                             
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="saveDatosBcraItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import { escapeSelector } from 'jquery';
import Vue from 'vue'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'


export default {
  data() {
    return {
      dialog: false,
      loading: false,
      editMode: false,
      suspend: false,
      verDetalle: true,
      verDatosBcra: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[10,25,50,100]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Empresa', value: 'empresa', sortable:true },
        { text: 'Nombre', value: 'nombre', sortable:true },
        { text: 'Producto', value: 'producto', sortable:true },
        { text: 'Anulado', value: 'anulado', sortable:true },
        { text: 'Acciones', value: 'name', sortable: false }
      ],     
      records: [], // registros
      selectedRow: [],
      productos:[],
      tablasCoeficientes:[],
      listaCoeficientes:[],
      listaCoeficientesAtraso: [],
      listaPoliticasComerciales : [],
      mediosCobro:[],
      mediosPago:[],
      condicionesPago:[],
      //nuevoCargo:{},
      vtosMensuales: [1,2,4],
      //momentosAplicacion:[{Id:1,Descripcion:'Alta'},{Id:2,Descripcion:'Cobranza'}],
      empresas : [],
      model: { grillaUnica: true,cargos:[],diasDeGracia:0,vencimiento:{},status:{}}, // registro para ver/editar
      modelBcra: {
        planId: 0,
        montoMaximoOtorgable: 0,
        montoMinimoOtorgable: 0,
        ingresoMinimoMensual: 0,
        antiguedadMinima: 0,
        edadMinima: 0,
        relacionCuotaIngreso:0,
        beneficiario: '',
        cargoMaximoCancelacionAnticipada: 0,
        territorioValidezOferta: '',
      },
      planSeleccionado: null,
      listModelosSMS: [],
    };
  },
  async created() {
    this.loadProductos();
    this.loadTiposMedioCobro();
    this.loadTiposMedioPago();
    this.loadTiposCondicionesPago();    
    this.loadTablasCoeficientes();
    this.loadTablasCoeficientesAtraso();
    this.loadEmpresas();
    this.loadPoliticasComerciales();
    this.loadModelosSMS();
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    },
    model() {
      
      this.model.vencimiento.segunFechaCobro = !this.model.vencimiento.diaFijo
    },
    'model.vencimiento.diaFijo': function(){     
        this.model.vencimiento.segunFechaCobro = !this.model.vencimiento.diaFijo;
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink','personaBusqueda']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    esProductoAdelanto() {
      return this.model.productoId == 37
    }
  },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    vigenciaDesdeChanged(newDate){
      this.model.vigenciaDesde = newDate
    },
    vigenciaHastaChanged(newDate){
      this.model.vigenciaHasta = newDate
    },
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {          
        var result = await http.get('planes?nombre='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false'));

        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()
    
      try {        
        var result = await http.get('planes/' +id );

        this.model = result;
        this.model.vigenciaDesdeFormatted =this.$moment(this.model.vigenciaDesde).format('YYYY-MM-DD') // creo una prop auxiliar para mostrar la fecha formateada
        this.model.vigenciaHastaFormatted =this.$moment(this.model.vigenciaHasta).format('YYYY-MM-DD')
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = { cargos:[],vencimiento:{},status:{}}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      this.verDetalle = true;
      this.verDatosBcra = false;

      if(!item){
        await this.getItem(0);
        this.model.grillaUnica = true;
      }
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);
      await this.$validator.validateAll()

      if(this.errors.items.length > 0) return;

      if (isUpdate) {
        try{
          await http.put('planes', JSON.stringify( {plan:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{          
          await http.post('planes', JSON.stringify( {plan:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación del plan ' + item.nombre + '?')) {
        try{
            await http.delete('planes?id='+item.id );
            this.alertSuccess('El plan ha sido eliminado.')
            this.clearAndReload();
        }
        catch(error){
            // Error
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('El plan no puede ser eliminado debido a que está asociada a uno o más canales de venta.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async loadProductos() {
        this.loading = true
        try {
            var result = await http.get('productos'); // traigo todas
            this.productos = result.list;
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadTablasCoeficientes() {
        this.loading = true
        try {
            var result = await http.get('tablasCoeficientes?limit=999'); // traigo todas
            this.tablasCoeficientes = result.list;
            
            this.tablasCoeficientes.unshift({id: 0, nombre:'(no disponible)'})

        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadTablasCoeficientesAtraso() {
        this.loading = true
        try {
            var result = await http.get('tablasCoeficientesCargos?limit=999'); // traigo todas
            this.listaCoeficientesAtraso = result.list;            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },    
    async loadTiposMedioCobro() {
        this.loading = true
        try {
            var result = await http.get('tiposmediocobro');
            this.mediosCobro = result.list;
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadTiposMedioPago() {
        this.loading = true
        try {
            var result = await http.get('tiposmediopagocredito');
            this.mediosPago = result.list;
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadTiposCondicionesPago() {
        this.loading = true
        try {
            var result = await http.get('tiposcondicionpago');
            this.condicionesPago = result.list;
            
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async traerCoeficientesTabla(tablaId){
      
      if(!tablaId){
         this.alertWarning('Por favor, seleccione una tabla de la lista antes de presionar el botón')
         return
      }

      try{
        this.loading=true;

        if( tablaId != 0)
        {
          var result = await http.get('tablasCoeficientes/' + tablaId );
        
          this.listaCoeficientes = result.coeficientes;
          this.dialog = true;
        }
      } catch (error) {
          this.alertError(error)
      }
      this.loading=false;
    },
    async loadEmpresas() {
        this.loading = true
        try {
            var result = await http.get('empresas'); // traigo todas
            this.empresas = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadPoliticasComerciales() {
        this.loading = true
        try {
            var result = await http.get('politicascomerciales');
            this.listaPoliticasComerciales = result.list;                      
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadModelosSMS() {
      this.loading = true;
      try {
        var result = await http.get('modelossms');
        this.listModelosSMS = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async verCanalesVenta(){
      try{
            var result = await http.get('planes/ListarCanalesVenta?planId='+this.model.id );

            this.listaCanalesVenta = result.list;
            this.dialogCanalesVenta = true;
        }
      catch (error) {
          // Error        
          this.alertError(error)
        }
    },
    guardarPlanComo(){
      this.model.id = 0;
      this.model.nombre = '';
      this.alertSuccess('El plan se copió en uno nuevo. Puede ingresar otro nombre, modificar los datos necesarios y guardarlo como un plan nuevo.')
    },
    generarReporte(plan){
      var params = {
          planId: plan.id,
          tablaCoeficientesId: plan.tablaCoeficientesId,
          empresaId: plan.empresaId,
          planNombre: plan.nombre,
          width:1000,
          visible: true
      };

      this.setActiveTask({task:'reporte-cuotas-por-plan', props: params})
    },
    async editDatosBcraItem(item){
      this.suspend = true;
      this.verDetalle = false;
      this.verDatosBcra = true;
      this.planSeleccionado = item;

      if(!item){
        await this.getDatosBcraItem(0);
        this.model.grillaUnica = true;
      }
      else
        await this.getDatosBcraItem(item.id);
        
      
    },
    async getDatosBcraItem(id){
    this.loading = true
    this.resetState()
      
      try{
        var result = await http.get('planes/datosBcra?id=' + id );
        this.modelBcra = result;
        
      }
        catch (error) {
        // Error        
        this.alertError(error)
      }
      this.loading = false;
    },
    async saveDatosBcraItem() {

     // if(!this.validarDatosBcra()) return;

        try{

          await http.post('planes/datosBcra', JSON.stringify( {planDatosBcra: this.modelBcra} ) );
     
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }
        
        this.getDatosBcraItem(this.modelBcra.planId);
    },
  }
}
</script>